<template lang="pug">
  el-container
    el-header(height="auto")
      el-form(inline label-suffix=":")
        city-select(v-model="city")
        el-form-item(label="时间")
          el-date-picker(
            v-model="timeRange"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd 00:00:00"
            :clearable="false"
            :picker-options="pickerOptions"
          )
        el-form-item
          el-button(
            type="primary"
            icon="el-icon-search"
            :disabled="!city || timeRange.length === 0"
            :loading="searching"
            @click="search"
            v-action="`datacenter_bike_table`"
          ) 搜索
        el-form-item
          el-button(
            type="primary"
            icon="el-icon-download"
            :disabled="!city || timeRange.length === 0"
            @click="download"
            v-action="`datacenter_bike_export`"
          ) 导出
    el-main
      grid(:remoteMethod="getTableData" ref="grid", :dispaly-pagination="false")
        -
          var columns = [
            { prop:"day", label:"时间"},
            { prop:"cityName", label:"城市名"},
            { prop:"serveCount", label:"累计投放车辆数"},
            { prop:"workingCount", label:"当日运营车辆数"},
            { prop:"successOrderCount", label:"当日完成订单数"},
            { prop:"freeOrderCount", label:"当日免费订单数"},
            { prop:"accumulativeRegistration", label:"累计注册用户数"},
            { prop:"accumulativeActive", label:"累计激活用户数"},
            { prop:"active", label:"当日激活用户数"},
            { prop:"avgUseCount", label:"车均使用次数"},
            { prop:"useCountLessThen3", label:"单车翻台低于3次"},
            { prop:"useCountEqualOrGreaterThen3", label:"单车翻台高于3次"},
          ];
        each item in columns
          el-table-column(
            prop=item.prop
            label=item.label
            min-width="130"
            v-if=`__action(table.${item.prop})`
          )
</template>

<script>
import { getSummaryData, downloadSummaryData } from '@/api/report';
import { download } from '@/utils';
import grid from '@/components/grid';
import citySelect from '@/components/citySelect';

export default {
  name: 'Operation',
  components: {
    grid,
    citySelect,
  },
  data() {
    return {
      city: '',
      searching: false,
      dialogVisible: false,
      timeRange: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() >= new Date().setHours(0, 0, 0, 0);
        }
      }
    };
  },
  computed: {
    table() {
      const handler = {
        get: (target, name) => `datacenter_bike_table_${name}`
      };
      return new Proxy({}, handler);
    }
  },
  mounted() {
  },
  methods: {
    async getTableData(data) {
      const res = await getSummaryData(data);
      return { data: res.data, total: res.total };
    },
    async download() {
      const data = {
        cityGuid: this.city,
        startDate: this.timeRange[0],
        endDate: this.timeRange[1],
      };
      const res = await downloadSummaryData(data);
      download(res.data.body);
    },
    async search() {
      if (!this.timeRange || !this.timeRange[0] || !this.timeRange[1]) return this.$message.error('日期不能为空');
      const data = {
        cityGuid: this.city,
        startDate: this.timeRange[0],
        endDate: this.timeRange[1],
      };
      this.searching = true;
      await this.$refs.grid.loadData(data);
      this.searching = false;
      return true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dataCenter/operation.vue?7289feb4